import { backgroundColor } from 'src/styling/variables'

export default {
  titleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row'
  },
  titleAndButtonsContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  error: {
    marginLeft: 12
  },
  subpageButton: {
    marginLeft: 12
  },
  buttonText: {
    color: backgroundColor,
    fontFamily: 'Mont',
    fontSize: 15
  },
  icon: {
    marginRight: 6
  },
  label: {
    marginRight: 24
  }
}
